<template>
  <div class="container">
    <!-- 处理完毕  -->
    <div class="box">
      <textarea v-reset-page  name id cols="30" rows="10" placeholder="您可以在此描述处理方法" v-model="content"></textarea>
    </div>
      <div class="btn" @click="handleClickEchoPage">提交</div>
  </div>
</template>

<script>
import { workorderSucess } from '@/api/workorder'
import { request } from 'http'
import { Toast } from 'vant'
export default {
   data() {
     return {
        content:''
     }
   },
   mounted() {
      console.log(this.$route.query.maintenanceFormId)
      console.log()
  
   },
   methods:{
    handleClickEchoPage() {
       
      this.requestWorkorderSucess()
    },
      // 处理完毕
    requestWorkorderSucess() {
      let maintenanceFormId = this.$route.query.maintenanceFormId
      let content = this.content
      if(!content) {
        Toast('内容不能为空')
        return false
      }
      workorderSucess({maintenanceFormId:maintenanceFormId,method:content}).then(res=>{
           if(res.code == 200) {
              this.$router.go(-1)
           }
      }) 
    }
   }
   
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
//   文本框
  .box {
    width: 100%;
    height: 230px;
    background-color: #ffffff;
    textarea {
        width: 100%;
        height: 100%;
        border: none;
        font-size: 14px;
        padding: 15px;
        box-sizing: border-box;
        color: #999999;
        &::-webkit-input-placeholder {
            color: #999999;
            font-size: 14px;
        }
    }
  }
//   提交
 .btn {
        width: 350px;
        height: 44px;
        background: -webkit-linear-gradient(left, #05AEFC, #008CFF);
        margin: 0 auto;
        border-radius: 22px;
        font-size: 16px;
        color: $white-color;
        line-height: 44px;
        margin:0 auto;
        margin-top: 289px;
     }
}
</style>
